import Select from 'react-select';
import { themedSelectMenuCss } from '../../../theme/selectStyles';
import styled from 'styled-components';

export const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  align-self: stretch;
  text-align: left;
  overflow: visible;
  & + & {
    margin-top: 22px;
  }
`;

export const StyledSectionLabel = styled.p`
  margin: 0;
  font-family: 'Archivo', sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.textFaint};
`;

export const StyledHint = styled.p`
  margin: 0;
  font-family: 'Archivo', sans-serif;
  font-size: 13px;
  line-height: 1.4;
  color: ${({ theme }) => theme.textMuted};
`;

export const StyledSelect = styled(Select)`
  width:100%; font-family:Archivo,sans-serif; font-size:14px;
  .react-select__control { min-height:42px; border-radius:10px; border:1px solid ${({theme})=>theme.border}; background:${({theme})=>theme.inset}; box-shadow:none; }
  .react-select__control--is-focused { border-color:${({theme})=>theme.headerAccent}; }
  .react-select__single-value { color:${({theme})=>theme.text}; }
  .react-select__indicator { color:${({theme})=>theme.textFaint}; }
  .react-select__indicator-separator { display:none; }
  ${themedSelectMenuCss}
`;

export const StyledAccentRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 4px;
  overflow: visible;
`;

export const StyledAccentChoice = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  margin: 0;
  padding: 4px;
  border: 0;
  background: transparent;
  cursor: pointer;
  overflow: visible;
  color: ${({ $selected, theme }) =>
    $selected ? theme.text : theme.textFaint};
  font-family: 'Archivo', sans-serif;
  font-size: 11px;
  font-weight: 600;
`;

export const StyledAccentSwatch = styled.span`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: ${({ $color }) => $color};
  box-shadow: ${({ $selected, $outline, theme }) =>
    $selected
      ? `0 0 0 2px ${theme.page}, 0 0 0 4px ${theme.headerAccent}`
      : $outline
        ? `inset 0 0 0 1px ${theme.border}, 0 0 0 1px ${theme.border}`
        : `0 0 0 1px ${theme.border}`};
`;

export const StyledRadiusPreview = styled.span`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
  height: 36px;
  padding: 6px 6px 4px;
  box-sizing: border-box;
  background: ${({ theme }) => theme.header};
  border-radius: ${({ $chrome }) => `${$chrome}px`};
  box-shadow: ${({ $selected, theme }) =>
    $selected
      ? `0 0 0 2px ${theme.page}, 0 0 0 4px ${theme.headerAccent}`
      : `0 0 0 1px ${theme.border}`};
  span {
    display: block;
    width: 100%;
    height: 18px;
    background: ${({ theme }) => theme.page};
    border-radius: ${({ $card }) => `${$card}px`};
  }
`;
